// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CaseOrderedRelationshipModel {
    static getAttributeTypeMap() {
        return CaseOrderedRelationshipModel.attributeTypeMap;
    }
}
CaseOrderedRelationshipModel.discriminator = undefined;
CaseOrderedRelationshipModel.attributeTypeMap = [
    {
        "name": "coverageOrder",
        "baseName": "coverageOrder",
        "type": "number"
    },
    {
        "name": "partyRoleId",
        "baseName": "partyRoleId",
        "type": "number"
    },
    {
        "name": "isPrimary",
        "baseName": "isPrimary",
        "type": "boolean"
    }
];
//# sourceMappingURL=caseOrderedRelationshipModel.js.map